import React, { useContext, useEffect, useState } from "react"
import { ChevronDown } from "react-feather"
import { useLocation } from "react-router-dom"
import ProductList from "@/ui/ProductList"
import Container from "@/components/Container"
import Button from "@/components/Button"
import DropDown, { Select, Option } from "@/components/DropDown"
import useClickOutside from "@/hooks/useClickOutside" 
import api from "../api"
import { CartContext, UserContext } from "@/App"
import CategoryList from "../ui/CategoryList"
import { CheckSquare, Square } from "lucide-react"

const sortOptions = [
  "popular",
  "new",
  "price: low to high",
  "price: high to low",
]

export default function ProductsPage() {
  const {cartDispatch} = useContext(CartContext)
  const {user} = useContext(UserContext)
  const query = new URLSearchParams(useLocation().search)
  const [products, setProducts] = useState([])
  const [sort, setSort] = useState(0)
  const [showSortOptions, setShowSortOptions] = useState(false)
  const dropDownRef = useClickOutside(() => setShowSortOptions(false))
  const [categories, setCategories] = useState([])
  const category = query.get("category")
  const categoryName = query.get("name")
  const [showAll, setShowAll] = useState(false)

useEffect(() => {
  let mounted = true;
  (async () => {
    const resp = await api.fetchProducts(category,false,showAll);
    // console.log("products",resp)
    if (mounted && resp.status !== "error") {
      setProducts(resp);
    }
  })();
  return () => { mounted = false };
}, [category,showAll]);

    useEffect(() => {
      let mounted = true;
      (async () => {
        const catResp = await api.fetchCategories()
        // console.log("categories",catResp)
        if (mounted && catResp.status !== "error") {
          const filtered = catResp.filter((cat)=> cat.parentId == Number(category))
          setCategories(filtered)
          // console.log("filtered categories",filtered)
        }
      })
      ();
       return () => { mounted = false };
    }, [category])

    useEffect(() => {
  if (products.length > 0) {
    const saved = sessionStorage.getItem("productsScrollY");

    if (saved) {
      window.scrollTo(0, parseInt(saved));
      sessionStorage.removeItem("productsScrollY");
    }
  }
}, [products]);

  useEffect(() => sortProducts(sort), [sort])

  const sortProducts = (sortType) => {
    switch (sortType) {
      case 1:
        setProducts([...products].sort((a, b) => a.updatedAt - b.updatedAt))
      case 2: 
        setProducts([...products].sort((a, b) => a.price - b.price))
        break
      case 3:
        setProducts([...products].sort((a, b) => b.price - a.price))
        break
      default:
        return
    }
  }

  const addToCart = async (product, quantity=1) => {
    if (user) {
      const resp = await api.addProductsToCart([{product:product, quantity}])
      
      if (resp) {
        cartDispatch({type: "ADD_PRODUCTS", payload: [{...product, quantity}]})
      }
    } else {
      cartDispatch({type: "ADD_PRODUCTS", payload: [{...product, quantity}]})
    }
  }

  return (
    // <main>
       
    //   {categories.length ?
    //    <Container  id="categories"
    //     heading={`Categories${categoryName ? " of: " + categoryName : ""}`}
    //    >

    //     <section className="flex justify-end">
    //         <Button
    //     onClick={() => setShowAll((prev) => !prev)}
    //     className="flex items-center shadow-none p-0 ,ml-2"
    //   >
    //     {showAll ? <CheckSquare /> : <Square />}
    //     <span>Show All</span>
    //   </Button>
    //     </section>


    //     <CategoryList categories={categories} />
    //     </Container>
    //     :<></>}
        
    //   <Container
    //     heading={`Products${categoryName ? " for: " + categoryName : ""}`}
    //     type="page"
    //   >
    //     <section className="flex justify-end">

    //       <div className="relative" ref={dropDownRef}>
            
    //         <span className="font-bold">Sort by:</span>
    //         <Button
    //           secondary
    //           onClick={() => setShowSortOptions((prev) => !prev)}
    //         >
    //           {sortOptions[sort]} <ChevronDown className="ml-2" />
    //         </Button>

    //         {showSortOptions && (
    //           <DropDown className="mt-10 inset-x-0" onClick={() => setShowSortOptions(false)}>
    //             <Select>
    //               {sortOptions.map((option, i) => (
    //                 <Option key={option} onClick={() => setSort(i)}>
    //                   {option}
    //                 </Option>
    //               ))}
    //             </Select>
    //           </DropDown>
    //         )}
    //       </div>
    //     </section>
    //     <ProductList products={products} onAddToCart={addToCart} />
    //   </Container>
    // </main>


    <main>
    {categories.length ? (
      <Container id="categories"
      heading={`Categories${categoryName ? " of " + categoryName : ""}`}
      >

    {/* Header Row */}
    <div className="flex items-center justify-between mb-4">

      <h2 className="text-xl font-semibold">
        {/* Categories{categoryName ? " of: " + categoryName : ""} */}
      </h2>
      <label className="flex items-center gap-3 cursor-pointer text-base font-semibold mr-6">
      <input
        type="checkbox"
        checked={showAll}
        onChange={() => setShowAll(prev => !prev)}
        className="w-6 h-6 accent-black"
      />
      Show All
      </label>
      </div>
      <CategoryList categories={categories} />
      </Container>
    ) : null}

      <Container
        heading={`Products${categoryName ? " for: " + categoryName : ""}`}
        type="page"
      >
      <section className="flex justify-end">
        <div className="relative" ref={dropDownRef}>
          <span className="font-bold mr-2">Sort by:</span>
          <Button
            secondary
            onClick={() => setShowSortOptions((prev) => !prev)}
          >
            {sortOptions[sort]}
            <ChevronDown className="ml-2" />
          </Button>

          {showSortOptions && (
            <DropDown className="mt-10 inset-x-0" onClick={() => setShowSortOptions(false)}>
              <Select>
                {sortOptions.map((option, i) => (
                  <Option key={option} onClick={() => setSort(i)}>
                    {option}
                  </Option>
                ))}
              </Select>
            </DropDown>
          )}
        </div>
      </section>

      <ProductList products={products} onAddToCart={addToCart} />
      </Container>
      </main>
  )
}
